// extracted by mini-css-extract-plugin
export var integrationButton = "_7r-0";